import type { NetworkItemState } from '../network/protocol';

const controls = ['Q', 'E', 'R'] as const;
export type ItemControl = typeof controls[number];

export function itemSlotControl(slot: number): ItemControl | undefined {
  return controls[slot];
}

/** Use the current authoritative inventory; starter bindings are not permanent. */
export function readyItemControl(
  items: readonly NetworkItemState[],
  id: NonNullable<NetworkItemState['id']>,
  cooldown: number,
): ItemControl | undefined {
  if (cooldown > 0.02) return undefined;
  for (let slot = 0; slot < controls.length; slot += 1) {
    const item = items[slot];
    if (item?.id === id && item.durability > 0) return controls[slot];
  }
  return undefined;
}
